export type PhlebotomySearchErrorCode =
  | "invalid_zip"
  | "zip_not_found"
  | "geocoding_unavailable"
  | "account_not_found"
  | "invalid_account"
  | "unknown";

const PHLEBOTOMY_SEARCH_ERROR_CODES = {
  invalid_zip: true,
  zip_not_found: true,
  geocoding_unavailable: true,
  account_not_found: true,
  invalid_account: true,
  unknown: true,
} as const satisfies Record<PhlebotomySearchErrorCode, true>;

export type PhlebotomySearchFailure = Error & {
  code: PhlebotomySearchErrorCode;
};

export const parsePhlebotomySearchErrorCode = (
  value: unknown,
): PhlebotomySearchErrorCode => {
  if (typeof value === "string" && value in PHLEBOTOMY_SEARCH_ERROR_CODES) {
    return value as PhlebotomySearchErrorCode;
  }
  return "unknown";
};

export const createPhlebotomySearchError = (
  message: string,
  code: PhlebotomySearchErrorCode,
): PhlebotomySearchFailure => Object.assign(new Error(message), { code });

export const isPhlebotomySearchFailure = (
  error: unknown,
): error is PhlebotomySearchFailure =>
  error instanceof Error &&
  "code" in error &&
  typeof error.code === "string" &&
  error.code in PHLEBOTOMY_SEARCH_ERROR_CODES;
